import React, { useEffect } from "react";
import {
  Accordion,
  Grid,
  Box,
  Button,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import ListMaker from "./ListMaker";

export default function Level5(props) {
  const [charState, setCharState] = React.useState([]);
  const [warState, setWarState] = React.useState([]);
  const [keepState, setKeepState] = React.useState([]);
  const [apprState, setApprState] = React.useState([]);
  const [usageState, setUsageState] = React.useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [level5, setLevel5] = React.useState([]);

  useEffect(() => {
    if (props.fireGetData) {
      props.getDataFromLevel5(level5);
    }
  }, [props.fireGetData]);

  return (
    <Accordion
      expanded={props.expanded === "panel5"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography sx={{ width: "33%", flexShrink: 0 }}>مرحله پنجم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          <Grid container>
            <ListMaker
              name="مشخصه های"
              state={charState.sort((a, b) => a.orderRow - b.orderRow)}
              setState={setCharState}
              deleteRow={(orderRow) => {
                let chars = charState;
                var newList = chars.filter((b) => b.orderRow !== orderRow);
                setCharState(newList);
              }}
            ></ListMaker>
            <ListMaker
              name="هشدارهای"
              state={warState.sort((a, b) => a.orderRow - b.orderRow)}
              setState={setWarState}
              deleteRow={(orderRow) => {
                let chars = warState;
                var newList = chars.filter((b) => b.orderRow !== orderRow);
                setWarState(newList);
              }}
            ></ListMaker>
            <ListMaker
              name="شرایط نگهداری"
              state={keepState.sort((a, b) => a.orderRow - b.orderRow)}
              setState={setKeepState}
              deleteRow={(orderRow) => {
                let chars = keepState;
                var newList = chars.filter((b) => b.orderRow !== orderRow);
                setKeepState(newList);
              }}
            ></ListMaker>
            <ListMaker
              name="متعلقات"
              state={apprState.sort((a, b) => a.orderRow - b.orderRow)}
              setState={setApprState}
              deleteRow={(orderRow) => {
                let chars = apprState;
                var newList = chars.filter((b) => b.orderRow !== orderRow);
                setApprState(newList);
              }}
            ></ListMaker>
            <ListMaker
              name="موارد مصرف"
              state={usageState.sort((a, b) => a.orderRow - b.orderRow)}
              setState={setUsageState}
              deleteRow={(orderRow) => {
                let chars = usageState;
                var newList = chars.filter((b) => b.orderRow !== orderRow);
                setUsageState(newList);
              }}
            ></ListMaker>
          </Grid>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel4");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              mergeAll();
            }}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function mergeAll() {
    setLevel5({
      characteristics: charState,
      warnings: warState,
      keepConditions: keepState,
      appurtenances: apprState,
      usages: usageState,
    });
    enqueueSnackbar("مرحله پنجم با موفقیت تکمیل شد", {
      variant: "success",
      autoHideDuration: 2000,
      preventDuplicate: true,
    });
    props.setExpanded("panel6");
  }
}
